export const LINK_EXPIRY_ERROR_CODE = 10043;
export const PAGE_NOT_FOUND_ERROR_CODE = 404;
export const ACCESS_ERROR_CODE = 10042;
export const INVALID_UUID_ERROR_CODE = 10005;
